// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"w0-z","subtitle":"x0-z","wrapper":"y0-z","leftArrow":"z0-z","rightArrow":"A0-z"};